import { render, staticRenderFns } from "./MapaPesca.vue?vue&type=template&id=47fae6aa"
import script from "./MapaPesca.vue?vue&type=script&lang=js"
export * from "./MapaPesca.vue?vue&type=script&lang=js"
import style0 from "./MapaPesca.vue?vue&type=style&index=0&id=47fae6aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports